/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_DescriptionInputs */

const en_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description`)
};

const he_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`תיאור`)
};

/**
* | output |
* | --- |
* | "Description" |
*
* @param {Jobs_DescriptionInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_description = /** @type {((inputs?: Jobs_DescriptionInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_DescriptionInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_description(inputs)
	return he_jobs_description(inputs)
});